import { QueryClient } from '@tanstack/react-query';
import { AuthExpiredError, isApiError } from './api';

/**
 * TanStack Query GERÇEKTEN kullanılır.
 *
 * snak'ta paket kuruluydu ama hiç import edilmemişti; her sayfa
 * useState+useEffect+fetch+loading+error dörtlüsünü yeniden yazmıştı. Sonuç:
 * kaydettikten sonra hangi verinin tazeleneceği elle takip ediliyordu ve
 * unutulan yerde ekran eski veriyi göstermeye devam ediyordu.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /*
       * Muhasebe verisi saniyede değişmez; pencereye her dönüşte yeniden
       * çekmek gereksiz yük ve gereksiz "yükleniyor" titremesi demek.
       */
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Kimlik/yetki hatası ve doğrulama hatası tekrar denemekle düzelmez.
        if (error instanceof AuthExpiredError) return false;
        if (isApiError(error) && error.status < 500 && error.status !== 429) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      // Bir mutasyon otomatik tekrar edilmez: iki kez fatura kesilmesin.
      retry: false,
    },
  },
});
